import { useEffect } from "react";

// Lightweight per-route <head> updates (title + description + OG).
// Static defaults live in public/index.html; this overrides per page.
export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title;
    const set = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[name="twitter:title"]', "content", title);
    set('meta[name="twitter:description"]', "content", description);
  }, [title, description]);
  return null;
}
